import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Header from "./components/sections/Header";
import HeroSection from "./components/sections/HeroSection";
import InsuranceSection from "./components/sections/InsuranceSection";
import AboutSection from "./components/sections/AboutSection";
import AmenitiesSection from "./components/sections/AmenitiesSection";
import DirectorSection from "./components/sections/DirectorSection";
import GallerySection from "./components/sections/GallerySection";
import TestimonialsSection from "./components/sections/TestimonialsSection";
import ContactSection from "./components/sections/ContactSection";
import HiringSection from "./components/sections/HiringSection";  // eslint-disable-line no-unused-vars
import VolunteerSection from "./components/sections/VolunteerSection";
import SocialSection from "./components/sections/SocialSection";
import NewsletterSection from "./components/sections/NewsletterSection";
import Footer from "./components/sections/Footer";

const HomePage = () => (
  <div className="min-h-screen bg-[color:var(--hc-cream)]">
    <Header />
    <main>
      <HeroSection />
      <InsuranceSection />
      <AboutSection />
      <AmenitiesSection />
      <DirectorSection />
      <GallerySection />
      <TestimonialsSection />
      <ContactSection />
      <VolunteerSection />
      <SocialSection />
      <NewsletterSection />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
